import React, {useCallback} from "react";
import {Switch} from "../../../../../../../../../components/base/switch";
import Button from "../../../../../../../../../components/base/button/button";

const FreeShippingFeesManagementViewSettingsSettingsSection = ({
                                                                   syncWithDetachedCustomers,
                                                                   setSyncWithDetachedCustomers,
                                                                   inUsersPanel,
                                                                   customerDetached,
                                                                   reattachCustomerToSystemRules,
                                                               }) => {


    /**
     * Confirms the removal of the given application with the user.
     */
    const confirmReattachment = useCallback(() => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    By attaching the customer to system rules, all of its custom rules will be overridden and lost. Do you wish to continue?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (confirmed) => confirmed && reattachCustomerToSystemRules(),
        );
    }, [reattachCustomerToSystemRules])

    return (
        <>
            <div className={'section'}>
                <div className={'section-paper'}>
                    <p className={'section-title'}>
                        Settings
                    </p>
                    {
                        !inUsersPanel &&
                        <>
                            <div className={'d-flex w-100 align-items-start justify-content-between'}>
                                <p className={'text-sm'}>
                                    Apply all the changes to the detached customers.
                                </p>
                                <Switch
                                    color={'primary'}
                                    checked={syncWithDetachedCustomers ?? false}
                                    onChange={setSyncWithDetachedCustomers}
                                />
                            </div>
                        </>
                    }
                    {
                        inUsersPanel && customerDetached &&
                        <>
                            <div className={'d-flex w-100 align-items-start justify-content-between'}>
                                <p className={'text-sm'}>
                                    This customer is detached from the system rules and is not following them.
                                </p>
                                <Button
                                    variant={'outlined'}
                                    color={'primary'}
                                    className={'ml-3'}
                                    onClick={confirmReattachment}
                                >
                                    Attach to system
                                </Button>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    );
}
export default FreeShippingFeesManagementViewSettingsSettingsSection;
